import ClientConfig from 'src/config/config.ts';

const parseExclusions = (input: string | string[] | undefined, options?: { ensureAtPrefix?: boolean }): string[] => {
  if (!input) {
    return [];
  }

  let items: string[] = [];
  if (Array.isArray(input)) {
    /*
     * DEPRECATED: Handling exclusions as arrays is deprecated (OW-25331)
     * Please use a comma-separated string instead.
     */
    console.warn(
      'Analytics server config: handling exclusions as arrays is deprecated (use a comma-separated string instead)',
    );
    items = input;
  } else {
    items = input.split(',');
  }

  return items
    .map((item) => {
      const normalized = item.trim().toLowerCase();
      if (options?.ensureAtPrefix && normalized.length > 0 && !normalized.startsWith('@')) {
        return `@${normalized}`;
      }
      return normalized;
    })
    .filter(Boolean);
};

/*
 * Disable analytics tracking according to server config
 */
export const isUserEmailExcludedFromAnalyticsTracking = (email?: string) => {
  if (!email) {
    return false;
  }
  const normalizedEmail = email.toLowerCase();
  const { analyticsEmailDomainExclusions, overrideAnalyticsEmailExclusions } = ClientConfig.config;

  const overrideExclusions = parseExclusions(overrideAnalyticsEmailExclusions);
  const domainExclusions = parseExclusions(analyticsEmailDomainExclusions, { ensureAtPrefix: true });

  const isOverridden = overrideExclusions.some((exclusion) => exclusion === normalizedEmail);
  if (isOverridden) {
    return false;
  }

  return domainExclusions.some((domain) => normalizedEmail.endsWith(domain));
};
